import MobileCard from "../../mobile-card/MobileCard";
import parametriImg from "../../../../assets/images/icon-big-monitoring-esim-88-px.svg";
import emailImg from "../../../../assets/images/icon-big-email-esim-88-px.svg";
import formatChangeImg from "../../../../assets/images/esim_change_format.svg";
import {routePaths} from "../../../../shared/utils/constants/routePaths";
import '../../Mobile.css';

const MonitoringESim = () => {
    const eSimCards = [
        {
            id: "report",
            imgSrc: emailImg,
            title: "Esito Invio email",
            description: "Sezione contenente l'elenco degli invii con i relativi esiti",
            to: routePaths.ESIM_INVIO_EMAIL,
        },
        {
            id: "sim",
            imgSrc: parametriImg,
            title: "Dettagli eSIM",
            description: "Monitoring delle informazioni puntuali per fare troubleshooting delle eSIM",
            to: routePaths.ESIM_PARAMETRI,
        },
        {
            id: "format-change",
            imgSrc: formatChangeImg,
            title: "Esito cambio formato",
            description: "Sezione contenente gli esiti delle richieste di cambio formato effettuate",
            to: routePaths.ESIM_FORMAT_CHANGE,
        }
        ]

    return (
        <div id='cards'>
            {eSimCards.map((cards) => {
                return <MobileCard key={`mobile-card-${cards.id}`}
                            imgSrc={cards.imgSrc}
                            title={cards.title}
                            description={cards.description}
                            to={cards.to}/>
            })}
        </div>
    )
}

export default MonitoringESim;
